import { useState } from 'react';
import poems from '../../database/poesias.json';

import styles from './Poems.module.css';

import ButtonLink from '../../components/ButtonLink';
import Title from '../../components/Title'

export default function Poems() {
  const [selectedPoem, setSelectedPoem] = useState(null);

  const openPoemModal = (poem) => {
    setSelectedPoem(poem);
  };

  const closePoemModal = () => {
    setSelectedPoem(null);
  };

  return (
    <div className={styles.container}>
      <div className={styles.poemsSection}>
        <div className={styles.containerHeader}>
          <Title fontSize='2.5rem' color='(--gray-900)'>Coleção de Poemas</Title>
        </div>
        <div className={styles.poemsGrid}>
          {poems.map((poem) => (
            <div 
              key={poem.id} 
              className={styles.poemCard}
              onClick={() => openPoemModal(poem)}
            >
              <p className={styles.poemExcerpt}>{poem.excerpt}</p>
              <p className={styles.poemAuthor}>{poem.author}</p>
              <ButtonLink fontSize='0.9rem' type='type2'>
                Ler poema completo
              </ButtonLink>
            </div>
          ))}
        </div>
      </div>

      {selectedPoem && (
        <div className={styles.modalOverlay} onClick={closePoemModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeButton} onClick={closePoemModal}>×</button>
            <p className={styles.modalAuthor}>{selectedPoem.author}</p>
            <div className={styles.poemText}>
              {selectedPoem.content.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}